const hostname = window.location.hostname.toLowerCase();

let baseURL = "";
if (hostname.includes("uat.novusloyalty.com")) {
  baseURL = "https://apiuat.novusloyalty.com/web/api/";
}
else if (hostname.includes("loyaltystaging.novusloyalty.com")) {
  baseURL = "https://apiloyaltystaging.novusloyalty.com/web/api/";
}
else {
  baseURL = "https://apiloyaltystaging.novusloyalty.com/web/api/";
}

export { baseURL };
